import {useState} from "react";
import {galleryService} from "../services/gallery-service";
import {openSuccessNotification, showErrorNotification} from "../helpers/mainHelpers";

export const useGalleryController = () => {
  const [images, setImages] = useState<string[]>([])
  const [isImagesLoading, setIsImagesLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)


  const toggleGalleryModal = () => {
    setIsModalOpen(!isModalOpen)
  }

  const getMainGalleryImages = async () => {
    setIsImagesLoading(true)
    try {
      const response = await galleryService.getGalleryImages()
      setImages(response)

    } catch (error) {
      console.error(error)
      showErrorNotification({message: "Помилка завантаження зображень!"});
    } finally {
      setIsImagesLoading(false)
    }
  }

  const updateGalleryImages = async (imagesId: string[]) => {
    setIsImagesLoading(true)
    try {
      const updatedImagesId = await galleryService.updateGalleryImages(imagesId)
      setImages(updatedImagesId)
      toggleGalleryModal()
      openSuccessNotification("Галерея успішно оновлена!")
    } catch (error) {
      showErrorNotification({message: "Помилка оновлення галереї!", description: JSON.stringify(error)});
    } finally {
      setIsImagesLoading(false)
    }
  }
  return {isImagesLoading, getMainGalleryImages, images, toggleGalleryModal, isModalOpen, updateGalleryImages}
}